import { type ReactNode } from 'react';
import { Button, Modal } from 'components/common';

interface ConfirmationModalProps {
  cancelButtonText?: string;
  children: ReactNode;
  confirmButtonText?: string;
  handleCancel?: (() => void) | null;
  handleConfirmation: () => void;
  hideModal: () => void;
  isConfirmDangerous?: boolean;
  showModal: boolean;
  title: string;
}

const ConfirmationModal = ({
  cancelButtonText = 'Cancel',
  children,
  confirmButtonText = 'Confirm',
  handleCancel = null,
  handleConfirmation,
  hideModal,
  isConfirmDangerous = false,
  showModal,
  title,
}: ConfirmationModalProps) => (
  <Modal onHide={hideModal} show={showModal} centered>
    <div className="p-3">
      <h4 className="fw-bold" data-testid="confirmation-modal-title">
        {title}
      </h4>
      <div className="my-4">{children}</div>
      <div className="d-flex">
        <Button
          onClick={handleConfirmation}
          testId="confirmation-modal-confirm-button"
          text="bold"
          variant={isConfirmDangerous ? 'danger' : 'primary-dark'}
        >
          {confirmButtonText}
        </Button>
        <div className="ms-2">
          <Button
            onClick={handleCancel ?? hideModal}
            testId="confirmation-modal-cancel-button"
            text="bold"
            variant="border"
          >
            {cancelButtonText}
          </Button>
        </div>
      </div>
    </div>
  </Modal>
);

export default ConfirmationModal;
